import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown, faCaretUp } from "@fortawesome/free-solid-svg-icons";

// The teams card's shared tooltip (see PointsPredictionTeamsCard)
export const TEAMS_TOOLTIP_ID = "teams-tooltip";

// Column header of the team tables that sorts by its column. `sort` is {key, direction};
// clicking the sorted column flips the direction, any other column sorts by that one.
// `tooltip` says what clicking does, in the site's tooltip style.
const SortHeader = ({ sortKey, sort, onSort, className = "", tooltip, children }) => {
    const active = sort.key === sortKey;
    return (
        <div className={className} role="columnheader"
             aria-sort={active ? (sort.direction === "asc" ? "ascending" : "descending") : "none"}>
            <button type="button" className={`sort-header ${active ? "active" : ""}`}
                    onClick={() => onSort(sortKey)}
                    data-tooltip-id={tooltip ? TEAMS_TOOLTIP_ID : undefined} data-tooltip-content={tooltip}>
                <span>{children}</span>
                <FontAwesomeIcon className="sort-header-icon" aria-hidden="true"
                                 icon={active && sort.direction === "asc" ? faCaretUp : faCaretDown}/>
            </button>
        </div>
    );
};

export default SortHeader;
